import { Component, EventEmitter, Host, Input, Optional, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services/helpers.service';
import { WorkshopJobcardCollectionsDeliveriesDetailsComponent } from './workshop-jobcard-collections-deliveries-details/workshop-jobcard-collections-deliveries-details.component';
import { WorkshopJobcardAccordionComponent } from '../workshop-jobcard-accordion/workshop-jobcard-accordion.component';

@Component({
  selector: 'app-workshop-jobcard-collecions-deliveries',
  templateUrl: './workshop-jobcard-collecions-deliveries.component.html',
  styleUrls: ['./workshop-jobcard-collecions-deliveries.component.scss']
})
export class WorkshopJobcardCollecionsDeliveriesComponent {

  @Input() jobcard: any = {};
  @Output() jobcardChange = new EventEmitter<any>();

  public countryData : any = {};

  constructor(
    private modalService: NgbModal,
    private helpersService: HelpersService,
    private translate: TranslateService,
    @Optional() @Host() private parentComponent: WorkshopJobcardAccordionComponent
  ) { }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
  }

  showCollectionDeliveryDetails() {
    const modalRef = this.modalService.open(WorkshopJobcardCollectionsDeliveriesDetailsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = JSON.parse(JSON.stringify(this.jobcard));

    modalRef.result.then(
      (result) => {
        if(result){
         this.jobcard = result;
        }
        this.jobcardChange.emit({ ...this.jobcard });
        if (this.parentComponent) {
          this.parentComponent.closeSection('services-products');
          this.parentComponent.closeSection('collections-deliveries');
          this.parentComponent.openSection('booking-details');
          this.parentComponent.openSection('extras');
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }




}
